<template>
	<div class="form-group clearfix">
		<div
			:class="{'float-left': (field.labelStyle=='justify'||field.labelStyle=='inline')}"
		>
			<label v-if="field.question" class="mr-2 align-top" :for="field.id">
				{{ field.question }}
				<span class="btn btn-primary btn-xs text-sm" @click="toggleInfo" v-if="hasInfo">Show Details</span>
			</label>
            <small 
                v-if="requiredIncomplete"
                class="ml-1" style="color:#FF0000"    
            >{{  $t('required')}}</small>
			<div v-if="field.description" v-html="field.description" class="mr-2"></div>
			<div v-if="(this.viewinfo && field.info)" v-html="field.info" class="mr-2 text-sm"></div>
			
		</div>
		<div :class="{'float-right': (field.labelStyle=='justify')}" v-bind:style="{ 'display': (field.labelStyle=='justify'||field.labelStyle=='inline'?'inline':'') }">

			<select
				v-if="(field.selectType && field.selectType == 'dropdown')"
				:disabled="readonly"
				v-model="field.value"
				:id="field.id"
				:aria-label="field.question"
				class="form-control"
                :class="{            
                	'requiredincomplete': requiredIncomplete,
            	}"
				>
				<option value="">{{$t('please-select')}}</option>
				<option
				v-for="(option, okey) in options"
				:key="okey"
				:value="option.value"
				:aria-label="`${field.question}: ${option.caption}`"
				>{{ option.caption }}</option>
			</select>

			<div
				:value="field.value"
				class="btn-group"
                :class="{
                	'requiredincomplete': requiredIncomplete,
					'btn-group-vertical-sm': buttonGroupVertical ,
					'btn-block': buttonGroupVertical ,
            	}"
				:id="field.id"
				:aria-label="field.question"
				v-else
			>
				<button
				v-for="(option, okey) in options"
				:key="okey"
				class="btn w-100"
				:class="getClassStr(option)"
				@click="field.value===option.value?field.value=null:field.value=option.value"
				:value="option.value"
				:disabled="readonly"
				:aria-label="`${field.question}: ${option.caption}`"
				:viewinfo="viewinfo"
				>
					<span class="option-header">{{ option.caption }}</span>
					<span v-if="(viewinfo && option.info)" class="option-info text-left"><br><span v-html="option.info"></span></span>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['field', 'readonly','viewAs'],
	data() {
		return {
			'viewinfo': false
		}
	},
	methods: {
		getClassStr(option) {
			if(this.field.value === option.value) {
				if(option.cssclass) {
					return `btn-on ${option.cssclass}`;
				} else {
					return 'btn-on';
				}
			} else {
				return 'btn-off';
			}
		},
        toggleInfo() {
        	this.viewinfo = !this.viewinfo;
        }
	},
	computed: {
		options() {
			if(this.field.optionsFromConfig) {
				const options = [];
				for(let option of this.$config.getValue(this.field.optionsFromConfig)) {
					options.push({
						value: option.id,
						caption: option.name,
						info: option.info
					})
				}
				return options;
			} else {
				return this.field.options;
			}
		},
        requiredIncomplete() {
            // null is the untouched/deselected default (see getDefaultField()) - a toggled-off
            // ('') field also counts as incomplete. 0 is a legitimate, deliberately-chosen value.
            return (this.field.permission.includes(this.viewAs) || this.field.permission.length === 0)
            && this.field.required && (this.field.value === null || this.field.value === '') ;
        },
        hasInfo() {
        	if(this.field.info) return true;
			for(let option of this.field.options) {
				if(option.info) return true;
			}
        	return false;
        },
		buttonGroupVertical() {
			for(let option of this.field.options) {
				if((option.caption || '').length > 5){
					return true;
				}
			}
			return false;
		},
	}
};
</script>
